import Vue from 'vue'
import store from '@state/store.js'
import incrementRetryCount from '@services/signalr/incrementRetryCount.js'
import signalRLogin from '@services/signalr/signalRLogin.js'

const start = async function() {
  let startedPromise = null

  store.commit('signalr/START_LOADING')

  startedPromise = Vue.prototype.$signalrConn
    .start()
    .then((value) => {
      // After a successful negotiation with SignalR, attempt to login
      signalRLogin()
      return value
    })
    .catch(async (err) => {
      console.error('Failed to connect with hub', err)

      return new Promise((resolve, reject) =>
        setTimeout(async () => {
          // Prevent retries if exceeded retry limit and if the user isn't authenticated
          if (!store.getters['auth/isUserLoggedIn'])
            await incrementRetryCount(10)

          if (!store.getters['signalr/hasExceededRetryLimit']) {
            await incrementRetryCount()
            return start()
              .then(resolve)
              .catch(reject)
          } else {
            reject(err)
          }
        }, store.getters['signalr/getTimeTillNextRetry'])
      )
    })

  store.commit('signalr/FINISH_LOADING')
  return startedPromise
}

export { start }
